import {objectEquals} from "./ObjectEquality";

export class ObjectUtil {

    public static merge(target: any, ...sources: Array<any>) {
        return sources.reduce((acc, next) => $.extend(true, acc, next), {});
    }

    public static copy<T>(value: null): null;
    public static copy<T>(value: T, overrides?: Partial<T>): T;

    public static copy<T>(value: T | null, overrides?: Partial<T>): T | null {
        if (value == null) {
            return null;
        } else if (ObjectUtil.isObject(value)) {
            return $.extend(true, {}, value, overrides);
        } else {
            return value;
        }
    }

    public static entry<T>(key: string | number, value: T) {
        return { [key]: value };
    }

    public static equals(a: any, b: any): boolean {
        return objectEquals(a, b);
    }

    /**
     * JSON Strings two objects to compare their value, may not be performant to use compared to other options
     * and will fail for objects with a circular reference
     */
    public static simpleEquals(a: any, b: any): boolean {
        try {
            return JSON.stringify(a) === JSON.stringify(b);
        } catch (e) {
            console.error("Unable to compare Dashboards", e);
            return false;
        }
    }

    public static isObject(value: any): value is object {
        return typeof value === "object";
    }

    public static isEmpty(value: object): boolean {
        return Object.keys(value).length === 0;
    }

    public static keys<T>(obj: T): Array<keyof T> {
        return Object.keys(obj) as Array<keyof T>;
    }

    public static entries<T, K extends keyof T>(val: T): Array<[K, T[K]]> {
        return ObjectUtil.keys(val)
                         .map((key) => [key, val[key]] as [K, T[K]]);
    }

    public static pick<T, K extends keyof T>(target: T, ...fields: Array<K>): Pick<T, K> {
        const result = {} as Pick<T, K>;
        fields.forEach((f) => result[f] = target[f]);
        return result;
    }
}
